import { render, staticRenderFns } from "./SuperAdminClientsPods.vue?vue&type=template&id=43570766&scoped=true&"
import script from "./SuperAdminClientsPods.vue?vue&type=script&lang=js&"
export * from "./SuperAdminClientsPods.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminClientsPods.vue?vue&type=style&index=0&id=43570766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43570766",
  null
  
)

export default component.exports